import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AutomationsPage } from '@web/modules/automations/list/automations-page';

/**
 * Keeps the list mounted under the editor dialog (`/automations/new`, `/automations/:id`).
 */
export const Route = createFileRoute('/_app/automations')({
  component: AutomationsLayout,
});

function AutomationsLayout() {
  return (
    <>
      <AutomationsPage />
      <Outlet />
    </>
  );
}
